module.exports = __webpack_public_path__ + "static/media/apercu-bold.027b3845.woff2";